const TYPES = Object.freeze({
});

const stateObject = {
  id: '',
  src: '',
  dest_name: '',
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  isFixed: false,
  isScaled: false,
};

const getters = {
  id: state => {
    return state.id
  },
  src: state => {
    return state.src
  },
  dest_name: state => {
    return state.dest_name
  },
  size: state => {
    let { width, height } = state
    return { width, height }
  },
  position: state => {
    let { top, left } = state
    return { top, left }
  },
  isFixed: state => {
    return state.isFixed
  },
  isScaled: state => {
    return state.isScaled
  }
};

const mutations = {
  SET_ID(state, id) {
    state.id = id
  },
  SET_SRC(state, src) {
    state.src = src
  },
  SET_DEST_NAME(state, dest_name) {
    state.dest_name = dest_name
  },
  SET_SIZE(state, { width, height }) {
    state.width = Math.floor(width)
    state.height = Math.floor(height)
  },
  SET_POSITION(state, { top, left }) {
    state.left = left
    state.top = top
  },
  SET_FIXED_STATE(state, isFixed) {
    state.isFixed = isFixed
  },
  SET_SCALE_STATE(state, isScaled) {
    state.isScaled = isScaled
  }
};

const actions = {
};

export default {
  namespaced: true,
  state: stateObject,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/cover-image.js